import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { User } from 'src/app/auth/models/user';
import { AuthService } from 'src/app/auth/services/auth.service';
import { AllowConfig } from '../models/allow-config.model';

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[ngAllow]' })
export class UserActionDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) { }

  @Input() set ngAllow(config: AllowConfig) {
    let readOnly = true;
    const _user = this.authService.storagedUser as User;
    if (_user.permissions.indexOf(config.permission) !== -1) {
      readOnly = false;
    } else {
      readOnly = true;
    }
    if (readOnly) {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
